import { css, SerializedStyles } from '@emotion/core';
import theme from '../../styles/theme';
import { screenSmall } from '../../styles/theme/breakpoints';
import { rem } from '../../styles/theme/layout';
import { StepState } from '../Steps/Steps';

export const getStatusColor = (stepState: StepState): string => {
  if (stepState.isActive) return theme.colors.lightBlue;
  if (stepState.isPassed) return theme.colors.gradientGreen;
  return theme.colors.labelGray;
};

const wrapper: SerializedStyles = css`
  box-sizing: border-box;
  align-items: center;
  text-transform: uppercase;
  flex-direction: column;
  justify-content: center;
  color: ${theme.colors.labelGray};
  font-family: ${theme.fonts.fontBold};
  padding: 0 ${theme.space[2]};
  position: relative;
`;

const circleWrapper = (stepState: StepState): SerializedStyles => css`
  width: ${rem(32)};
  height: ${rem(32)};
  position: relative;
  background-color: ${getStatusColor(stepState)};
  font-size: ${theme.fonts[3]};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-bottom: ${theme.space[1]};
  color: ${theme.colors.white};
  transition: transform 0.3s ease-in-out;
  ${stepState.isPassed &&
  `&:hover {
      transition: transform 0.3s ease-in-out;
      transform: scale(1.1);
      cursor: pointer;
    }`};
`;

const label = (stepState: StepState): SerializedStyles => css`
  font-size: ${theme.fontSizes[1]};
  white-space: nowrap;
  position: absolute;
  top: ${rem(40)};
  color: ${getStatusColor(stepState)};
  @media screen and (max-width: ${screenSmall}) {
    display: none;
  }
`;

export default {
  wrapper,
  circleWrapper,
  label,
};
